import { SeparatorProps, typedMemo } from "src/types";
import { concatClasses } from "src/utils";

export const Separator = typedMemo(({ classes }: SeparatorProps) => {
  return <div className={concatClasses("border-top", classes)} />;
});
